import { Radio } from "lucide-react";
import type { ModuleSpec } from "../types";

export const channelsSpec: ModuleSpec = {
  id: "channels",
  icon: Radio,
  i18n: {
    namespace: "modules",
    titleKey: "channels.title",
    descriptionKey: "channels.description",
  },
  nav: {
    path: "/channels",
    group: "connect",
    order: 10,
  },
  permission: {
    action: "read",
    subject: "channel",
  },
  meta: {
    status: "active",
    description: "Connect communication channels",
  },
};
